import * as GlobalTypes from "../../types";
import { PortTypeValues } from "../../config";

export type ConfigurableFields = {
    Name: string,
    Id: string,
    Pattern: string,
    Regex: string,
    Default: string
}

export type Catalog = {
    /** E.g: "10/13/2025, 3:29:14 PM" */
    timestamp: string,
    /** E.g: 1760387354939 */
    version: number,
}

export enum CatalogItemTaints {
    OneWayCommunication = "OneWayCommunication",
}

/**
 * Format of the common part of the JSON catalog files. 
 */
export type CatalogItem = {
    /** Unique id that specifies a given product family,
     * - It is `brand-model` for a pump and for pump, it is a unique row from the catalog.
     * - For a salt cell it is `brand-model` but it just selects a salt cell family only, not a unique entity that a HW Config could reference.
     *   itemId + supportedCells[].model together defines a unique entity for the HW Config.
     * 
     */
    itemId:string;
    brand:string;
    model:string;
    powerPort?: GlobalTypes.BoolStringShort,
    description: string,
    /** @deprecated Removed in Catalog v32. */
    controlType?: GlobalTypes.ControlTypes,
    /** Added in Catalog v32 */
    portTypesAvailable: PortTypeValues[],
    notes: string,
    kbUrl: string,
    busClass: string,
    addressUniqueType: string,
    uiElementID: string,
    configurableFields: ConfigurableFields[],
    troubleshooting: { [ key: string ]: any }[],
    /** Comma separated list of CatalogItemTaints items */
    taints?: string,
}
